import React from "react";
import { observer } from "mobx-react";
import {
  convertFormattedDateToISO,
  getDateFormat,
  getDateRegex,
} from "shared/dateTimeUtils";
import InputMask from "react-input-mask";

export default observer(function SearchForm({
  searchConfig,
  searchParams,
  parent,
  search,
  resetSearch,
}) {
  if (!searchConfig) return null;
  return (
    <>
      <form className="search" onSubmit={search} onReset={resetSearch}>
        {searchConfig.map((field, i) => (
          <div className="input-group" key={i}>
            <label htmlFor={field.fieldId} id={`for-${field.fieldId}`}>
              {field.label}
            </label>
            <SearchFormInput field={field} searchParams={searchParams} />
          </div>
        ))}
        <input type="reset" className="btn secondary" aria-label="reset" />
        <input
          type="submit"
          aria-label="Search"
          className="btn"
          disabled={parent.store.loading ? "disabled" : null}
        />
      </form>
      {parent.store.noSearchRequirements ? (
        <div className="warning">At least one field is required to search</div>
      ) : parent.store.patients.length || parent.store.loading ? null : (
        <div className="warning">No Results for Search Criteria</div>
      )}
    </>
  );
});

function SearchFormInput({ field, searchParams }) {
  const type = fieldType(field);
  const inputProps = {
    name: field.fieldId,
    id: field.fieldId,
    defaultValue: searchParams?.[field.fieldId] || "",
    "aria-labelledby": `for-${field.fieldId}`,
    placeholder: field.placeHolder,
  };

  if (type === "date") {
    const placeHolder = getDateFormat().replace("LL", "MM").toUpperCase();
    const pattern = getDateRegex();
    const inputRef = React.useRef();
    return (
      <>
        <InputMask
          mask="99/99/9999"
          {...inputProps}
          placeholder={placeHolder}
          onChange={() => {
            const value = inputRef.current?.getInputValue();
            const input = inputRef.current?.getInputDOMNode();
            const invalid =
              input?.vaildity?.patternMismatch ||
              (value && !convertFormattedDateToISO(value));
            if (invalid) {
              input.setCustomValidity(
                "Must be a valid Date in the format " + placeHolder,
              );
            } else {
              input.setCustomValidity("");
            }
          }}
          pattern={pattern}
          ref={inputRef}
        />
      </>
    );
  }

  if (type === "text") inputProps.minLength = 2;

  return (
    <input
      id={field.fieldId}
      name={field.fieldId}
      {...inputProps}
      type={type}
      onChange={(e) => {
        const input = e.target;
        if (input.validity.tooShort)
          input.setCustomValidity(`${inputProps.minLength} character minimum`);
        else input.setCustomValidity("");
      }}
    />
  );
}

// public enum UIKeyboardType
// {
// UIKeyboardTypeDefault = 0,
// UIKeyboardTypeASCIICapable = 1,
// UIKeyboardTypeNumbersAndPunctuation = 2,
// UIKeyboardTypeURL = 3,
// UIKeyboardTypeNumberPad = 4,
// UIKeyboardTypePhonePad = 5,
// UIKeyboardTypeNamePhonePad = 6,
// UIKeyboardTypeEmailAddress = 7,
// UIKeyboardTypeDecimalPad = 8,
// DATE = 9,
// }
export function fieldType(field) {
  const types = {
    0: "text",
    2: "number",
    9: "date",
  };
  return types[field.textKeyboardType] || types[0];
}
